// import http from "./http";

// // ADD
// export const createGameResult = async (data) => {
//   const res = await http.post("selection_game_result", {
//     ...data,
//     action: "add",
//   });
//   return res.data;
// };

// // LIST
// export const getGameResults = async () => {
//   const res = await http.get("selection_game_result");
//   return res.data;
// };

// // UPDATE (FIXED → game_id)
// export const updateGameResult = async (game_id, data) => {
//   const res = await http.post("selection_game_result", {
//     ...data,
//     action: "edit",
//     game_id,
//   });
//   return res.data;
// };

// // DELETE (FIXED → game_id)
// export const deleteGameResult = async (game_id) => {
//   const res = await http.post("selection_game_result", {
//     action: "delete",
//     game_id,
//   });
//   return res.data;
// };

import http from "./http";

/* ================= ADD (BULK SAFE) ================= */
export const createGameResult = async (data) => {
  const res = await http.post("selection_game_result", {
    league_id: Number(data.league_id),
    action: "add",
    settlements: data.settlements,   // 🔥 directly pass array
  });

  return res.data;
};

/* ================= EDIT ================= */
export const updateGameResult = async (data) => {
  const res = await http.post("selection_game_result", {
    league_id: Number(data.league_id),
    action: "edit",
    settlements: [
      {
        game_id: Number(data.game_id),
        match_id: Number(data.match_id),
        winning_option_id: Number(data.winning_option_id),
      },
    ],
  });

  return res.data;
};

/* ================= DELETE ================= */
export const deleteGameResult = async (data) => {
  const res = await http.post("selection_game_result", {
    league_id: Number(data.league_id),
    action: "delete",
    settlements: [
      {
        game_id: Number(data.game_id),
        match_id: Number(data.match_id),
      },
    ],
  });

  return res.data;
};

/* ================= GET ALL ================= */
export const getGameResults = async () => {
  const res = await http.get("selection_game_result");
  return res.data;
};

/* ================= DETAILS ================= */
export const getGameResultDetails = async (game_id) => {
  const res = await http.get(
    `selection_game_result?game_id=${game_id}`
  );
  return res.data;
};